module.exports = __webpack_public_path__ + "static/media/gem-black.912d00f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/gem-black.svg
// module id = 33
// module chunks = 0